// extracted by mini-css-extract-plugin
export default {"pagination":"paginateCard_pagination__xJ+RC","active":"paginateCard_active__kcCKR"};